module.exports = __webpack_public_path__ + "media/images/webpage/hotels/staff_members/landlady-72c05d89ef3763e19622bab8ad11c5d7.webp";